import React from 'react';
import { StrongText } from '../blogCard/blogCardStyle';

interface HtmlContentProps {
  html: string;
  readMore: any;
  maxLength?: number;
}

const HtmlContent: React.FC<HtmlContentProps> = ({ html,readMore, maxLength = 150 }) => {

  const sanitizeHtml = (html: string) => {
    // Basic sanitization to remove script tags
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const scripts = tempDiv.getElementsByTagName('script');
    while (scripts.length > 0) {
      scripts[0].parentNode?.removeChild(scripts[0]);
    }
    return tempDiv.innerHTML;
  };

  const truncateHtml = (html: string, maxLength: number): string => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    let charCount = 0;
    const truncatedContent: string[] = [];

    const traverseNodes = (node: Node) => {
      if (charCount >= maxLength) {
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const textNode = node as Text;
        if (charCount + textNode.length > maxLength) {
          const remainingLength = maxLength - charCount;
          truncatedContent.push(textNode.nodeValue!.substring(0, remainingLength));
          charCount = maxLength;
        } else {
          truncatedContent.push(textNode.nodeValue!);
          charCount += textNode.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const elementNode = node as HTMLElement;
        const outerHtml = elementNode.outerHTML.split('>');
        truncatedContent.push(outerHtml[0] + '>');
        Array.from(node.childNodes).forEach(traverseNodes);
        truncatedContent.push(`</${elementNode.nodeName.toLowerCase()}>`);
      }
    };

    Array.from(tempDiv.childNodes).forEach(traverseNodes);
    return truncatedContent.join('');
  };

  const sanitizedHtml = sanitizeHtml(html);

  return (
    <div>
        <div>
          <div dangerouslySetInnerHTML={{ __html: truncateHtml(sanitizedHtml, maxLength) }} />
          ...<StrongText onClick={readMore}>Read More</StrongText>
        </div>
    </div>
  );
};

export default HtmlContent;
